
// // export default GmbAuditPage;

// // src/components/BrandAudit/Step8_MapRanking.jsx
// import React, { useState, useEffect, useRef, useCallback } from 'react';
// import { GoogleMap, Marker, InfoWindow, Circle } from '@react-google-maps/api';
// import { useGoogleMaps } from '../../hooks/useGoogleMaps';
// import { auditAPI } from '../../services/api';
// import { GoogleGenerativeAI } from '@google/generative-ai';

// const CACHE_TTL = 24 * 60 * 60 * 1000;
// const GEMINI_API_KEY = process.env.REACT_APP_GEMINI_API_KEY || '';

// const cleanDomain = (url) =>
//   url?.replace(/^https?:\/\//, '').replace(/^www\./, '').split('/')[0].toLowerCase().trim();

// // ─── Gemini API wrapper ────────────────────────────────────────────────────
// const genAI = new GoogleGenerativeAI(GEMINI_API_KEY);
// const callGemini = async (prompt) => {
//   if (!GEMINI_API_KEY) throw new Error('REACT_APP_GEMINI_API_KEY not set in .env');
//   try {
//     const model = genAI.getGenerativeModel({ model: 'gemini-2.5-flash' });
//     const result = await model.generateContent(prompt);
//     const response = await result.response;
//     return response.text();
//   } catch (error) {
//     console.error('Gemini SDK error:', error);
//     throw new Error('Gemini API request failed');
//   }
// };

// // ─── AI Insight Box ────────────────────────────────────────────────────────
// const INSIGHT_TTL = 24 * 60 * 60 * 1000;

// const AIInsightBox = ({ prompt, cacheKey, title = 'Map Ranking Insight', autoGenerate = true }) => {
//   const [aiText, setAiText]     = useState('');
//   const [aiLoading, setAiLoading] = useState(false);
//   const [aiError, setAiError]   = useState('');
//   const generatedRef             = useRef(false);
//   const [isPlaying, setIsPlaying] = useState(false);
//   const [isPaused, setIsPaused]   = useState(false);
//   const utteranceRef              = useRef(null);

//   useEffect(() => () => window.speechSynthesis.cancel(), []);

//   useEffect(() => {
//     if (!cacheKey) return;
//     generatedRef.current = false;
//     try {
//       const cached = localStorage.getItem(`ai_insight_${cacheKey}`);
//       if (cached) {
//         const { ts, text } = JSON.parse(cached);
//         if (Date.now() - ts < INSIGHT_TTL && text) {
//           setAiText(text);
//           return;
//         }
//       }
//     } catch {}
//     if (autoGenerate && !generatedRef.current) {
//       generatedRef.current = true;
//       generate();
//     }
//   // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [cacheKey]);

//   const generate = async () => {
//     if (!prompt) return;
//     setAiLoading(true);
//     setAiError('');
//     try {
//       const text = await callGemini(prompt);
//       setAiText(text);
//       if (cacheKey) {
//         localStorage.setItem(`ai_insight_${cacheKey}`, JSON.stringify({ ts: Date.now(), text }));
//       }
//     } catch (e) {
//       setAiError('Could not generate insight. Check your API key.');
//       console.error(e);
//     } finally {
//       setAiLoading(false);
//     }
//   };

//   const togglePlayback = () => {
//     const synth = window.speechSynthesis;
//     if (isPlaying) {
//       synth.pause();
//       setIsPlaying(false);
//       setIsPaused(true);
//     } else {
//       if (isPaused && synth.paused) {
//         synth.resume();
//         setIsPlaying(true);
//         setIsPaused(false);
//       } else {
//         synth.cancel();
//         const utterance = new SpeechSynthesisUtterance(aiText.replace(/<[^>]*>/g, ''));
//         utterance.lang = 'en-IN';
//         utterance.onend  = () => { setIsPlaying(false); setIsPaused(false); };
//         utterance.onerror = () => { setIsPlaying(false); setIsPaused(false); };
//         utteranceRef.current = utterance;
//         synth.speak(utterance);
//         setIsPlaying(true);
//         setIsPaused(false);
//       }
//     }
//   };

//   return (
//     <div className="insight-box">
//       <div className="insight-header">
//         <div className="insight-title">
//           <svg viewBox="0 0 24 24" width="20" height="20">
//             <path d="M12 2a7 7 0 00-7 7c0 2.6 1.4 4.9 3.5 6.2V17a1 1 0 001 1h5a1 1 0 001-1v-1.8C17.6 13.9 19 11.6 19 9a7 7 0 00-7-7zm2 17h-4v1a1 1 0 001 1h2a1 1 0 001-1v-1z" />
//           </svg>
//           {title}
//         </div>
//         {aiText && !aiLoading && (
//           <button className="play-btn" onClick={togglePlayback}>
//             <svg viewBox="0 0 24 24" width="12" height="12">
//               {isPlaying
//                 ? <path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z" />
//                 : <path d="M8 5v14l11-7z" />}
//             </svg>
//             {isPlaying ? 'Pause' : 'Play'}
//           </button>
//         )}
//       </div>
//       {aiLoading   && <div style={{ fontSize: 13, color: '#6B4FA0' }}>Generating AI insight…</div>}
//       {aiError && !aiLoading && <div style={{ fontSize: 12, color: '#c62828' }}>{aiError}</div>}
//       {aiText && !aiLoading && <div className="insight-text" style={{ marginTop: 8 }}>{aiText}</div>}
//       {!aiText && !aiLoading && !aiError && (
//         <div style={{ fontSize: 12, color: '#aaa', fontStyle: 'italic' }}>AI insight will appear here shortly.</div>
//       )}
//     </div>
//   );
// };

// // ─────────────────────────────────────────────────────────────────────────
// // Normalise center — API returns different shapes
// // ─────────────────────────────────────────────────────────────────────────
// const normaliseCenter = (c) => {
//   if (!c) return null;
//   const lat = c.lat ?? c.latitude ?? c.Lat ?? null;
//   const lng = c.lng ?? c.longitude ?? c.Lng ?? c.lon ?? null;
//   if (lat == null || lng == null) return null;
//   return { lat: Number(lat), lng: Number(lng) };
// };

// // ─────────────────────────────────────────────────────────────────────────
// // FIX 3: Resolve a fallback center from any ranking cache entries
// // Called when the map has no center yet (e.g. public / share view).
// // Scans all gmbRanking_ keys for the given domain and returns the first
// // valid center it finds.
// // ─────────────────────────────────────────────────────────────────────────
// const resolveFallbackCenter = (domain, placeId) => {
//   try {
//     for (let i = 0; i < localStorage.length; i++) {
//       const key = localStorage.key(i);
//       if (!key) continue;
//       if (!key.startsWith('gmbRanking_')) continue;
//       // Prefer keys that match our domain or placeId
//       if (domain && !key.includes(domain) && placeId && !key.includes(placeId)) continue;
//       const raw = localStorage.getItem(key);
//       if (!raw) continue;
//       const parsed = JSON.parse(raw);
//       const center = normaliseCenter(parsed?.data?.center);
//       if (center) return center;
//     }
//   } catch {}
//   return null;
// };

// // ─────────────────────────────────────────────────────────────────────────
// // Main Component
// // ─────────────────────────────────────────────────────────────────────────
// const GmbAuditPage = ({ brandName, websiteUrl, location, placeId, competitors, onContinue }) => {
//   const { isLoaded, loadError } = useGoogleMaps();
//   const [loading, setLoading]               = useState(true);
//   const [pillarKeywords, setPillarKeywords] = useState([]);
//   const [selectedKeyword, setSelectedKeyword] = useState('');
//   const [rankingData, setRankingData]       = useState(null);
//   const [centerCellTop, setCenterCellTop]   = useState([]);
//   const [rankingCenter, setRankingCenter]   = useState(null);
//   const [gridRadius, setGridRadius]         = useState(1.5);
//   const [dragCenter, setDragCenter]         = useState(null);
//   const [hoveredPin, setHoveredPin]         = useState(null);
//   const [mapInstance, setMapInstance]       = useState(null);
//   const isDragging                          = useRef(false);
//   const [currentInsightPrompt, setCurrentInsightPrompt] = useState('');
//   const [currentCacheKey, setCurrentCacheKey]           = useState('');

//   const domain = cleanDomain(websiteUrl);

//   // Load pillar keywords from localStorage
//   useEffect(() => {
//     const stored = localStorage.getItem('auditFormData');
//     if (stored) {
//       try {
//         const formData = JSON.parse(stored);
//         const keywords = (formData.pillarKeywords || []).filter(Boolean);
//         setPillarKeywords(keywords);
//         if (keywords.length) setSelectedKeyword(keywords[0]);
//       } catch {}
//     }
//   }, []);

//   const activeCenter = dragCenter || rankingCenter;

//   // ── FIX 3: If we still have no center after the map renders, try to pull
//   //    one from any gmbRanking_ cache (covers the public / copy-link view).
//   useEffect(() => {
//     if (!rankingCenter && !dragCenter && isLoaded) {
//       const fallback = resolveFallbackCenter(domain, placeId);
//       if (fallback) setRankingCenter(fallback);
//     }
//   }, [isLoaded, rankingCenter, dragCenter, domain, placeId]);

//   const getCenterRank    = (grid) => (!grid || grid.length < 5) ? null : grid[4];
//   const getLocalPackCount = (grid) => {
//     if (!grid || grid.length !== 9) return 0;
//     return grid.filter((r, i) => i !== 4 && r >= 1 && r <= 3).length;
//   };

//   const fetchRankingData = useCallback(async (forceRefresh = false, customCenter = null) => {
//     // ── Bail BEFORE setLoading(true) so the spinner never gets stuck ──────
//     if (!selectedKeyword) {
//       setLoading(false);
//       return;
//     }

//     // ── If placeId is empty (e.g. public/share view), try to load ANY
//     //    matching gmbRanking_ cache entry for this domain + keyword ─────────
//     if (!placeId || !location) {
//       try {
//         const prefix = `gmbRanking_${domain}_`;
//         for (let i = 0; i < localStorage.length; i++) {
//           const key = localStorage.key(i);
//           if (!key?.startsWith(prefix)) continue;
//           if (!key.includes(`_${selectedKeyword}_`)) continue;
//           const raw = localStorage.getItem(key);
//           if (!raw) continue;
//           const { timestamp, data } = JSON.parse(raw);
//           if (Date.now() - timestamp < CACHE_TTL && data) {
//             setRankingData(data.grid || null);
//             setCenterCellTop(data.centerCellTop || []);
//             const centre = normaliseCenter(data.center);
//             if (centre) setRankingCenter(centre);
//           }
//           break; // use first match
//         }
//       } catch {}
//       setLoading(false);
//       return;
//     }

//     setLoading(true);
//     const centerKey = customCenter
//       ? `${customCenter.lat.toFixed(4)},${customCenter.lng.toFixed(4)}`
//       : 'default';
//     const cacheKey = `gmbRanking_${domain}_${placeId}_${selectedKeyword}_${centerKey}_${gridRadius}`;
//     const now = Date.now();

//     if (!forceRefresh) {
//       const cached = localStorage.getItem(cacheKey);
//       if (cached) {
//         try {
//           const { timestamp, data } = JSON.parse(cached);
//           if (now - timestamp < CACHE_TTL) {
//             setRankingData(data.grid || null);
//             setCenterCellTop(data.centerCellTop || []);
//             const centre = normaliseCenter(data.center);
//             if (centre) setRankingCenter(centre);
//             setLoading(false);
//             return;
//           }
//         } catch {
//           console.warn('Cache parse failed, refetching');
//         }
//       }
//     }

//     try {
//       const payload = {
//         domain,
//         keyword:       selectedKeyword,
//         location:      customCenter
//           ? `${customCenter.lat},${customCenter.lng}`
//           : location,
//         place_ids:     { brand: placeId },
//         force_refresh: forceRefresh,
//         radius_km:     gridRadius,
//       };
//       const response = await auditAPI.gmbranking(payload);
//       let grid = null, centerTop = [], center = null;
//       const rd = response?.data;

//       if (rd?.ranking?.results?.brand?.grid) {
//         grid      = rd.ranking.results.brand.grid;
//         centerTop = rd.ranking.center_cell_top || [];
//         center    = rd.ranking.center;
//       } else if (rd?.results?.brand?.grid) {
//         grid      = rd.results.brand.grid;
//         centerTop = rd.center_cell_top || [];
//         center    = rd.center;
//       } else if (response?.results?.brand?.grid) {
//         grid      = response.results.brand.grid;
//         centerTop = response.center_cell_top || [];
//         center    = response.center;
//       }

//       const normCenter = normaliseCenter(center);
//       if (normCenter) setRankingCenter(normCenter);
//       setCenterCellTop(centerTop);
//       setRankingData(grid);

//       localStorage.setItem(cacheKey, JSON.stringify({
//         timestamp: now,
//         data: { grid, centerCellTop: centerTop, center: normCenter },
//       }));
//     } catch (err) {
//       console.error('Ranking fetch failed', err);
//     } finally {
//       setLoading(false);
//     }
//   }, [domain, selectedKeyword, location, placeId, gridRadius]);

//   useEffect(() => {
//     if (selectedKeyword) fetchRankingData(false);
//   }, [selectedKeyword, gridRadius, fetchRankingData]);

//   // Build AI insight prompt
//   useEffect(() => {
//     if (!selectedKeyword || !rankingData || !centerCellTop.length) {
//       setCurrentInsightPrompt('');
//       return;
//     }
//     const centerRank = getCenterRank(rankingData);
//     const packCount  = getLocalPackCount(rankingData);
//     const rank       = centerRank || 0;
//     const rankDesc   = rank === 0 ? 'Not Ranked' : rank;
//     const packText   = packCount === 0 ? 'none' : packCount;
//     const locationName = location || 'your area';

//     const prompt = `You are a senior local SEO strategist preparing a professional brand audit report. Business-appropriate language. No bullet points. Maximum 3 sentences.

// Brand: ${brandName}
// Location: ${locationName}
// Keyword: ${selectedKeyword}
// Google Maps Rank: ${rankDesc}
//   (1-3 = Local Pack  |  4-6 = Near Pack  |  7+ = Low Visibility  |  0 = Not Ranked)
// Local Pack appearances across grid: ${packText} of 8 locations

// Provide a professional assessment of this brand's local search ranking for the specified keyword. Quantify the visibility gap in terms of customer acquisition opportunity. Articulate the commercial value of achieving a Local Pack position for this search term.`;

//     setCurrentInsightPrompt(prompt);
//     setCurrentCacheKey(`map_insight_${domain}_${selectedKeyword}`);
//   }, [selectedKeyword, rankingData, brandName, location, domain]);

//   const generateGridPoints = (lat, lng, stepKm = 1.5) => {
//     const points   = [];
//     const stepLat  = stepKm / 111;
//     const stepLng  = stepKm / (111 * Math.cos(lat * Math.PI / 180));
//     for (let i = -1; i <= 1; i++)
//       for (let j = -1; j <= 1; j++)
//         points.push({ lat: lat + i * stepLat, lng: lng + j * stepLng });
//     return points;
//   };

//   const renderFallbackPins = () => {
//     if (!activeCenter) return [];
//     return generateGridPoints(activeCenter.lat, activeCenter.lng, gridRadius).map((p, idx) => ({
//       id: `fallback-${idx}`,
//       name: `Location ${idx + 1}`,
//       rank: Math.floor(Math.random() * 10) + 1,
//       lat: p.lat,
//       lng: p.lng,
//       address: 'Simulated address',
//     }));
//   };

//   const mapOptions = {
//     zoomControl: true,
//     streetViewControl: false,
//     mapTypeControl: false,
//     fullscreenControl: false,
//     gestureHandling: 'cooperative',
//   };

//   if (loadError) return <div className="card">Map failed to load. Please check your Google Maps API key.</div>;
//   if (!isLoaded) return <div className="card">Loading map…</div>;

//   return (
//     <div className="card" id="card-8">
//       {/*
//         ── FIX 2 + 3: PDF keyword label ─────────────────────────────────────
//         Visible only during print so the PDF reader knows which keyword's
//         map ranking is displayed (the interactive dropdown & controls are
//         hidden by the @media print CSS).
//       */}
//       <style>{`
//         @media print {
//           .map-kw-print-label { display: block !important; }
//         }
//         .map-kw-print-label { display: none; }
//       `}</style>

//       <div className="eyebrow">Local Ranking Insight</div>
//       <h2 className="ctitle">Local Search Ranking</h2>
//       <p className="cdesc">
//         Where your brand ranks on Google Maps for each keyword — across a local grid around your business location.
//       </p>

//       {loading && (
//         <div className="gmb-rank-fetch show">
//           <div className="spinner" />
//           <span>Checking local map rankings for your keywords…</span>
//         </div>
//       )}

//       <div className="gmb-rank-wrap" style={{ display: loading ? 'none' : 'block' }}>

//         {/* FIX 2: print-only keyword label */}
//         <div className="map-kw-print-label" style={{
//           fontSize: 13, fontWeight: 600, color: '#6B4FA0',
//           marginBottom: 12, padding: '6px 12px',
//           background: 'rgba(107,79,160,0.07)', borderRadius: 8, display: 'none',
//         }}>
//           Keyword: <strong>{selectedKeyword}</strong>
//         </div>

//         {/* Controls — hidden in print via existing CSS */}
//         <div className="map-controls">
//           <select
//             className="kw-select"
//             value={selectedKeyword}
//             onChange={(e) => setSelectedKeyword(e.target.value)}
//             style={{ pointerEvents: 'auto', cursor: 'pointer' }}
//           >
//             {pillarKeywords.length
//               ? pillarKeywords.map(kw => <option key={kw} value={kw}>{kw}</option>)
//               : <option>No keywords</option>}
//           </select>
//           <div className="radius-wrap">
//             Grid radius
//             <input
//               type="range" min="1" max="5" step="0.5"
//               value={gridRadius}
//               onChange={(e) => setGridRadius(parseFloat(e.target.value))}
//             />
//             <span className="radius-val">{gridRadius} km</span>
//           </div>
//           {dragCenter && (
//             <button
//               className="cc-btn"
//               onClick={() => { setDragCenter(null); fetchRankingData(true); }}
//             >
//               Reset pin
//             </button>
//           )}
//         </div>

//         {/* Legend */}
//         <div className="map-legend">
//           <div className="mleg"><div className="mleg-dot mleg-pack" /></div> #1–3 Local Pack
//           <div className="mleg"><div className="mleg-dot mleg-near" /></div> #4–6 Near Pack
//           <div className="mleg"><div className="mleg-dot mleg-weak" /></div> #7–9 Weak
//           <div className="mleg"><div className="mleg-dot mleg-no" /></div>   Not Ranked
//           <div className="mleg"><div className="mleg-dot mleg-center" /></div> Center
//         </div>

//         {/* ── FIX 3: Map container ── */}
//         <div className="map-outer">
//           {activeCenter ? (
//             <GoogleMap
//               mapContainerStyle={{ width: '100%', height: '100%' }}
//               center={{ lat: activeCenter.lat, lng: activeCenter.lng }}
//               zoom={13}
//               onLoad={setMapInstance}
//               options={mapOptions}
//             >
//               <Circle
//                 center={{ lat: activeCenter.lat, lng: activeCenter.lng }}
//                 radius={gridRadius * 1000}
//                 options={{
//                   strokeColor: '#378ADD', strokeOpacity: 0.4, strokeWeight: 1.5,
//                   fillColor: '#378ADD',   fillOpacity: 0.05,
//                 }}
//               />
//               <Marker
//                 position={{ lat: activeCenter.lat, lng: activeCenter.lng }}
//                 draggable={true}
//                 onDragStart={() => { isDragging.current = true; }}
//                 onDragEnd={(e) => {
//                   const newCenter = { lat: e.latLng.lat(), lng: e.latLng.lng() };
//                   isDragging.current = false;
//                   setDragCenter(newCenter);
//                   fetchRankingData(true, newCenter);
//                 }}
//                 icon={{
//                   path: window.google.maps.SymbolPath.CIRCLE,
//                   scale: 12,
//                   fillColor: '#378ADD', fillOpacity: 1,
//                   strokeColor: '#fff',  strokeWeight: 2,
//                 }}
//               />
//               {!loading && (rankingData ? centerCellTop : renderFallbackPins()).map((entry, idx) => {
//                 const rank    = entry.rank || (idx + 1);
//                 const isBrand = entry.id === placeId;
//                 const angle   = (idx / Math.max(centerCellTop.length, 5)) * 2 * Math.PI;
//                 const offsetKm = 0.35 + (idx % 3) * 0.2;
//                 const lat = entry.lat || (activeCenter.lat + (offsetKm / 111) * Math.cos(angle));
//                 const lng = entry.lng || (activeCenter.lng + (offsetKm / (111 * Math.cos(activeCenter.lat * Math.PI / 180))) * Math.sin(angle));
//                 const pinColor = isBrand ? '#059669' : rank <= 3 ? '#059669' : rank <= 6 ? '#d97706' : '#dc2626';
//                 return (
//                   <Marker
//                     key={entry.id || idx}
//                     position={{ lat, lng }}
//                     onClick={() => setHoveredPin({ ...entry, rank, lat, lng })}
//                     icon={{
//                       path: window.google.maps.SymbolPath.CIRCLE,
//                       scale: isBrand ? 14 : 10,
//                       fillColor: pinColor, fillOpacity: 1,
//                       strokeColor: '#fff', strokeWeight: isBrand ? 3 : 2,
//                     }}
//                     label={{ text: String(rank), color: '#fff', fontSize: '10px', fontWeight: '500' }}
//                   />
//                 );
//               })}
//               {hoveredPin && (
//                 <InfoWindow
//                   position={{ lat: hoveredPin.lat, lng: hoveredPin.lng }}
//                   onCloseClick={() => setHoveredPin(null)}
//                 >
//                   <div>
//                     <div style={{ fontWeight: 500 }}>#{hoveredPin.rank} · {hoveredPin.name}</div>
//                     <div style={{ fontSize: 11, color: '#666' }}>{hoveredPin.address}</div>
//                   </div>
//                 </InfoWindow>
//               )}
//             </GoogleMap>
//           ) : (
//             /*
//               FIX 3: Show a helpful message when center is not yet resolved.
//               In the public/share view the center comes from the restored
//               gmbRanking_ cache.  If it's still null after the effect above
//               runs, it means no ranking data was captured yet — tell the user.
//             */
//             <div className="map-bg" style={{
//               display: 'flex', flexDirection: 'column',
//               alignItems: 'center', justifyContent: 'center',
//               height: '100%', gap: 8, color: '#8B82A0', fontSize: 13,
//             }}>
//               <svg viewBox="0 0 24 24" width="32" height="32" fill="#C4BDD6">
//                 <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
//               </svg>
//               <span>Map data not available for this view.</span>
//               <span style={{ fontSize: 11, color: '#C4BDD6' }}>Run the audit first to capture location data.</span>
//             </div>
//           )}
//         </div>

//         {/* Ranking List */}
//         <div className="rank-legend">
//           <div className="rank-legend-title">Rankings for center location</div>
//           <div className="rank-items">
//             {!loading && (rankingData ? centerCellTop : renderFallbackPins()).map((entry, idx) => {
//               const rank    = entry.rank || (idx + 1);
//               const isBrand = entry.id === placeId;
//               const rankColor = rank > 6 ? '#dc2626' : rank > 3 ? '#d97706' : '#059669';
//               return (
//                 <div key={idx} className="rank-item">
//                   <div className="rank-pos" style={{ background: rankColor }}>{rank}</div>
//                   <span className="rank-biz">
//                     {entry.name}
//                     {isBrand && (
//                       <span style={{ fontSize: 10, color: 'var(--thistle)', marginLeft: 6 }}>· Your Brand</span>
//                     )}
//                   </span>
//                 </div>
//               );
//             })}
//           </div>
//         </div>

//         {/* AI Insight */}
//         {currentInsightPrompt && currentCacheKey && !loading && (
//           <AIInsightBox
//             key={currentCacheKey}
//             title="Map Ranking Insight"
//             cacheKey={currentCacheKey}
//             prompt={currentInsightPrompt}
//             autoGenerate={!!GEMINI_API_KEY}
//           />
//         )}
//         {!currentInsightPrompt && !loading && (
//           <div className="insight-box">
//             <div className="insight-header">
//               <div className="insight-title">
//                 <svg viewBox="0 0 24 24" width="20" height="20">
//                   <path d="M12 2a7 7 0 00-7 7c0 2.6 1.4 4.9 3.5 6.2V17a1 1 0 001 1h5a1 1 0 001-1v-1.8C17.6 13.9 19 11.6 19 9a7 7 0 00-7-7zm2 17h-4v1a1 1 0 001 1h2a1 1 0 001-1v-1z" />
//                 </svg>
//                 Local Ranking Insight
//               </div>
//             </div>
//             <div className="insight-text">
//               {centerCellTop.length
//                 ? `Your brand ${brandName} ${centerCellTop[0]?.rank ? `ranks #${centerCellTop[0].rank}` : 'does not appear'} for "${selectedKeyword}" at the center location. ${
//                     centerCellTop[0]?.rank <= 3 ? 'This is in the Local Pack!' :
//                     centerCellTop[0]?.rank <= 6 ? 'Close to the Local Pack.' :
//                     'Optimise your GMB profile.'
//                   }`
//                 : 'No ranking data available. Try a different keyword or location.'}
//             </div>
//           </div>
//         )}
//       </div>

//       <button className="btn" onClick={onContinue} style={{ marginTop: 20 }}>
//         View AI Presence
//         <svg viewBox="0 0 24 24" fill="white">
//           <path d="M12 4l-1.4 1.4L16.2 11H4v2h12.2l-5.6 5.6L12 20l8-8z" />
//         </svg>
//       </button>
//     </div>
//   );
// };

// export default GmbAuditPage;
// src/components/BrandAudit/Step8_MapRanking.jsx
// src/components/BrandAudit/Step8_MapRanking.jsx
import React, { useState, useEffect, useRef, useCallback } from 'react';
import { auditAPI } from '../../services/api';
import { GoogleGenerativeAI } from '@google/generative-ai';

const CACHE_TTL = 24 * 60 * 60 * 1000;
const GEMINI_API_KEY = process.env.REACT_APP_GEMINI_API_KEY || '';

const cleanDomain = (url) =>
  url?.replace(/^https?:\/\//, '').replace(/^www\./, '').split('/')[0].toLowerCase().trim();

// ─── Gemini API wrapper ────────────────────────────────────────────────────
const genAI = new GoogleGenerativeAI(GEMINI_API_KEY);
const callGemini = async (prompt) => {
  if (!GEMINI_API_KEY) throw new Error('REACT_APP_GEMINI_API_KEY not set in .env');
  try {
    const model = genAI.getGenerativeModel({ model: 'gemini-2.5-flash' });
    const result = await model.generateContent(prompt);
    const response = await result.response;
    return response.text();
  } catch (error) {
    console.error('Gemini SDK error:', error);
    throw new Error('Gemini API request failed');
  }
};

// ─── AI Insight Box ────────────────────────────────────────────────────────
const INSIGHT_TTL = 24 * 60 * 60 * 1000;

const AIInsightBox = ({ prompt, cacheKey, title = 'Map Ranking Insight', autoGenerate = true }) => {
  const [aiText, setAiText]       = useState('');
  const [aiLoading, setAiLoading] = useState(false);
  const [aiError, setAiError]     = useState('');
  const generatedRef               = useRef(false);
  const [isPlaying, setIsPlaying]  = useState(false);
  const [isPaused, setIsPaused]    = useState(false);
  const utteranceRef               = useRef(null);

  useEffect(() => () => window.speechSynthesis.cancel(), []);

  useEffect(() => {
    if (!cacheKey) return;
    generatedRef.current = false;
    try {
      const cached = localStorage.getItem(`ai_insight_${cacheKey}`);
      if (cached) {
        const { ts, text } = JSON.parse(cached);
        if (Date.now() - ts < INSIGHT_TTL && text) {
          setAiText(text);
          return;
        }
      }
    } catch {}
    if (autoGenerate && !generatedRef.current) {
      generatedRef.current = true;
      generate();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cacheKey]);

  const generate = async () => {
    if (!prompt) return;
    setAiLoading(true);
    setAiError('');
    try {
      const text = await callGemini(prompt);
      setAiText(text);
      if (cacheKey) {
        localStorage.setItem(`ai_insight_${cacheKey}`, JSON.stringify({ ts: Date.now(), text }));
      }
    } catch (e) {
      setAiError('Could not generate insight. Check your API key.');
      console.error(e);
    } finally {
      setAiLoading(false);
    }
  };

  const togglePlayback = () => {
    const synth = window.speechSynthesis;
    if (isPlaying) {
      synth.pause();
      setIsPlaying(false);
      setIsPaused(true);
    } else if (isPaused && synth.paused) {
      synth.resume();
      setIsPlaying(true);
      setIsPaused(false);
    } else {
      synth.cancel();
      const utterance = new SpeechSynthesisUtterance(aiText.replace(/<[^>]*>/g, ''));
      utterance.lang = 'en-IN';
      utterance.onend = () => { setIsPlaying(false); setIsPaused(false); };
      utterance.onerror = () => { setIsPlaying(false); setIsPaused(false); };
      utteranceRef.current = utterance;
      synth.speak(utterance);
      setIsPlaying(true);
      setIsPaused(false);
    }
  };

  return (
    <div className="insight-box" id="insight-box-8">
      <div className="insight-header">
        <div className="insight-title">
          <svg viewBox="0 0 24 24" width="20" height="20">
            <path d="M12 2a7 7 0 00-7 7c0 2.6 1.4 4.9 3.5 6.2V17a1 1 0 001 1h5a1 1 0 001-1v-1.8C17.6 13.9 19 11.6 19 9a7 7 0 00-7-7zm2 17h-4v1a1 1 0 001 1h2a1 1 0 001-1v-1z" />
          </svg>
          {title}
        </div>
        {aiText && !aiLoading && (
          <button className="play-btn" onClick={togglePlayback}>
            <svg viewBox="0 0 24 24" width="12" height="12">
              {isPlaying
                ? <path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z" />
                : <path d="M8 5v14l11-7z" />}
            </svg>
            {isPlaying ? 'Pause' : 'Play'}
          </button>
        )}
      </div>
      {aiLoading && <div style={{ fontSize: 13, color: '#6B4FA0' }}>Generating AI insight…</div>}
      {aiError && !aiLoading && <div style={{ fontSize: 12, color: '#c62828' }}>{aiError}</div>}
      {aiText && !aiLoading && <div className="insight-text" id="insight-text-8">{aiText}</div>}
      {!aiText && !aiLoading && !aiError && (
        <div style={{ fontSize: 12, color: '#aaa', fontStyle: 'italic' }}>AI insight will appear here shortly.</div>
      )}
    </div>
  );
};

// ─── Normalise center ──────────────────────────────────────────────────────
const normaliseCenter = (c) => {
  if (!c) return null;
  const lat = c.lat ?? c.latitude ?? c.Lat ?? null;
  const lng = c.lng ?? c.longitude ?? c.Lng ?? c.lon ?? null;
  if (lat == null || lng == null) return null;
  return { lat: Number(lat), lng: Number(lng) };
};

// ─── Resolve fallback center from cache ───────────────────────────────────
const resolveFallbackCenter = (domain, placeId) => {
  try {
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (!key) continue;
      if (!key.startsWith('gmbRanking_')) continue;
      if (domain && !key.includes(domain) && placeId && !key.includes(placeId)) continue;
      const raw = localStorage.getItem(key);
      if (!raw) continue;
      const parsed = JSON.parse(raw);
      const center = normaliseCenter(parsed?.data?.center);
      if (center) return center;
    }
  } catch {}
  return null;
};

// ─── Rank colour / class helpers ──────────────────────────────────────────
const rankColor  = (r) => r <= 3 ? '#16a34a' : r <= 6 ? '#d97706' : r <= 9 ? '#ea580c' : '#dc2626';
const rankBg     = (r) => r <= 3 ? '#f0fdf4' : r <= 6 ? '#fffbeb' : r <= 9 ? '#fff7ed' : '#fef2f2';
const rankBorder = (r) => r <= 3 ? '#bbf7d0' : r <= 6 ? '#fde68a' : r <= 9 ? '#fed7aa' : '#fecaca';
const rankLabel  = (r) => (r >= 20 ? '20+' : `${r}`);
const rankMsg    = (r) =>
  r <= 3 ? 'Excellent — top of local pack' :
  r <= 6 ? 'Good — near pack visibility' :
  r <= 9 ? 'Weak — below local pack' : 'Low — not in visible pack';
// class names matching the new design's map legend / pin styling
const rankPinClass = (r) => r <= 3 ? 'pin-pack' : r <= 6 ? 'pin-near' : r <= 9 ? 'pin-weak' : 'pin-no';

// ─── Grid index → compass key mapping ─────────────────────────────────────
// API returns 3×3 grid: indices 0-8 reading left→right, top→bottom
// 0=NW  1=N   2=NE
// 3=W   4=CTR 5=E
// 6=SW  7=S   8=SE
const GRID_MAP = {
  N1: 1, N2: 0, N3: 2,
  W1: 3, W2: 0, W3: 6,
  E1: 5, E2: 2, E3: 8,
  center: 4,
  S1: 7, S2: 6, S3: 8,
};

// ─── Simulated map position for each compass key (% of map-outer box) ─────
const RING_OFFSET = { 1: 34, 2: 21, 3: 8 }; // percent-from-center, ring 1 = closest
const pinPosition = (compassKey) => {
  if (compassKey === 'center') return { top: 50, left: 50 };
  const axis = compassKey[0];       // N / S / E / W
  const ring = Number(compassKey[1]); // 1 / 2 / 3
  const off = RING_OFFSET[ring] ?? 34;
  switch (axis) {
    case 'N': return { top: 50 - off, left: 50 };
    case 'S': return { top: 50 + off, left: 50 };
    case 'E': return { top: 50, left: 50 + off };
    case 'W': return { top: 50, left: 50 - off };
    default:  return { top: 50, left: 50 };
  }
};

const DIR_LABELS = {
  N1: '1 km North', N2: '2 km North', N3: '3 km North',
  E1: '1 km East',  E2: '2 km East',  E3: '3 km East',
  S1: '1 km South', S2: '2 km South', S3: '3 km South',
  W1: '1 km West',  W2: '2 km West',  W3: '3 km West',
  center: 'Your location (center)',
};

// ─── Main Component ────────────────────────────────────────────────────────
const GmbAuditPage = ({ brandName, websiteUrl, location, placeId, competitors, onContinue }) => {
  const [loading, setLoading]                   = useState(true);
  const [pillarKeywords, setPillarKeywords]      = useState([]);
  const [selectedKeyword, setSelectedKeyword]   = useState('');
  const [rankingData, setRankingData]           = useState(null);   // 9-cell array
  const [centerCellTop, setCenterCellTop]       = useState([]);     // top competitors at center
  const [rankingCenter, setRankingCenter]       = useState(null);
  const [selectedPin, setSelectedPin]           = useState(null);   // { key, rank }
  const [currentInsightPrompt, setCurrentInsightPrompt] = useState('');
  const [currentCacheKey, setCurrentCacheKey]           = useState('');
  const [resolvedPlaceId, setResolvedPlaceId]   = useState(placeId || '');
  const [resolvedLocation, setResolvedLocation] = useState(location || '');
  const domain = cleanDomain(websiteUrl);
  const [selectedPinEntries, setSelectedPinEntries] = useState([]);
  const [gridRadius, setGridRadius] = useState(1.5);

  // ── Load pillar keywords ─────────────────────────────────────────────────
  useEffect(() => {
    const stored = localStorage.getItem('auditFormData');
    if (stored) {
      try {
        const formData = JSON.parse(stored);
        const keywords = (formData.pillarKeywords || []).filter(Boolean);
        setPillarKeywords(keywords);
        if (keywords.length) setSelectedKeyword(keywords[0]);
      } catch {}
    }
  }, []);

  useEffect(() => {
    try {
      const stored = localStorage.getItem('auditFormData');
      if (stored) {
        const formData = JSON.parse(stored);
        if (!resolvedPlaceId && formData.placeId) {
          setResolvedPlaceId(formData.placeId);
        }
        if (!resolvedLocation && formData.locations?.[0]?.city) {
          setResolvedLocation(formData.locations[0].city);
        }
      }
    } catch {}
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // ── Fallback center from any cache ───────────────────────────────────────
  useEffect(() => {
    if (!rankingCenter) {
      const fallback = resolveFallbackCenter(domain, placeId);
      if (fallback) setRankingCenter(fallback);
    }
  }, [rankingCenter, domain, placeId]);

  const fetchAndCacheGmbRanking = async (domain, keyword, location, placeId, gridRadius) => {
    try {
      const payload = {
        domain,
        keyword,
        location,
        place_ids:     { brand: placeId },
        force_refresh: false,
        radius_km:     gridRadius,
      };
      const response = await auditAPI.gmbranking(payload);
      const rd = response?.data;

      let grid = null, centerTop = [], center = null;

      if (rd?.ranking?.results?.brand?.grid) {
        grid      = rd.ranking.results.brand.grid;
        centerTop = rd.ranking.center_cell_top || [];
        center    = rd.ranking.center;
      } else if (rd?.results?.brand?.grid) {
        grid      = rd.results.brand.grid;
        centerTop = rd.center_cell_top || [];
        center    = rd.center;
      } else if (response?.results?.brand?.grid) {
        grid      = response.results.brand.grid;
        centerTop = response.center_cell_top || [];
        center    = response.center;
      }

      const normCenter = normaliseCenter(center);
      const cacheKey   = `gmbRanking_${domain}_${placeId}_${keyword}_default_${gridRadius}`;

      localStorage.setItem(cacheKey, JSON.stringify({
        timestamp: Date.now(),
        data: { grid, centerCellTop: centerTop, center: normCenter },
      }));

      console.log(`✅ Fetched & cached GMB Ranking for ${domain} — ${keyword}`);
      return { grid, centerCellTop: centerTop, center: normCenter };

    } catch (e) {
      console.warn(`❌ GMB Ranking fetch failed:`, e);
      return null;
    }
  };

  // ── Helpers ───────────────────────────────────────────────────────────────
  const getCenterRank     = (grid) => (!grid || grid.length < 5) ? null : grid[4];
  const getLocalPackCount = (grid) => {
    if (!grid || grid.length !== 9) return 0;
    return grid.filter((r, i) => i !== 4 && r >= 1 && r <= 3).length;
  };

  // ── Fetch ranking data ────────────────────────────────────────────────────
  const fetchRankingData = useCallback(async (forceRefresh = false) => {
    if (!selectedKeyword) { setLoading(false); return; }

    setLoading(true);

    const centerKey = 'default';
    const cacheKey  = `gmbRanking_${domain}_${resolvedPlaceId}_${selectedKeyword}_${centerKey}_${gridRadius}`;

    // ── Step 1: check cache ───────────────────────────────────────────────
    if (!forceRefresh) {
      const cached = localStorage.getItem(cacheKey);
      if (cached) {
        try {
          const { timestamp, data } = JSON.parse(cached);
          if (Date.now() - timestamp < CACHE_TTL && data) {
            console.log(`⚡ GMB Ranking cache hit: ${selectedKeyword}`);
            setRankingData(data.grid || null);
            setCenterCellTop(data.centerCellTop || []);
            const centre = normaliseCenter(data.center);
            if (centre) setRankingCenter(centre);
            setLoading(false);
            return;
          }
        } catch {
          console.warn('Cache parse failed, refetching');
        }
      }
    }

    // ── Step 2: cache miss — fetch from API ───────────────────────────────
    if (!resolvedPlaceId || !resolvedLocation) {
      console.warn('⚠️ No placeId or location — cannot fetch GMB ranking');
      setLoading(false);
      return;
    }

    console.log(`🔄 GMB Ranking cache miss — fetching: ${selectedKeyword}`);
    const result = await fetchAndCacheGmbRanking(
      domain, selectedKeyword, resolvedLocation, resolvedPlaceId, gridRadius
    );

    if (result) {
      setRankingData(result.grid || null);
      setCenterCellTop(result.centerCellTop || []);
      const centre = normaliseCenter(result.center);
      if (centre) setRankingCenter(centre);
    }

    setLoading(false);
  }, [domain, selectedKeyword, resolvedLocation, resolvedPlaceId, gridRadius]);

  useEffect(() => {
    if (selectedKeyword) fetchRankingData(false);
  }, [selectedKeyword, gridRadius, fetchRankingData]);

  // ── Build AI insight prompt ───────────────────────────────────────────────
  useEffect(() => {
    if (!selectedKeyword || !rankingData || !centerCellTop.length) {
      setCurrentInsightPrompt('');
      return;
    }
    const centerRank = getCenterRank(rankingData);
    const packCount  = getLocalPackCount(rankingData);
    const rank       = centerRank || 0;
    const rankDesc   = rank === 0 ? 'Not Ranked' : rank;
    const packText   = packCount === 0 ? 'none' : packCount;
    const locationName = resolvedLocation || 'your area';

    const prompt = `You are a senior local SEO strategist preparing a professional brand audit report. Business-appropriate language. No bullet points. Maximum 3 sentences.

Brand: ${brandName}
Location: ${locationName}
Keyword: ${selectedKeyword}
Google Maps Rank: ${rankDesc}
  (1-3 = Local Pack  |  4-6 = Near Pack  |  7+ = Low Visibility  |  0 = Not Ranked)
Local Pack appearances across grid: ${packText} of 8 locations

Provide a professional assessment of this brand's local search ranking for the specified keyword. Quantify the visibility gap in terms of customer acquisition opportunity. Articulate the commercial value of achieving a Local Pack position for this search term.`;

    setCurrentInsightPrompt(prompt);
    setCurrentCacheKey(`map_insight_${domain}_${selectedKeyword}`);
  }, [selectedKeyword, rankingData, brandName, resolvedLocation, domain]);

  // ── Grid rank lookup ──────────────────────────────────────────────────────
  const getRank = (compassKey) => {
    if (!rankingData) return 20;
    const idx = GRID_MAP[compassKey];
    if (idx === undefined) return 20;
    const val = rankingData[idx];
    return val != null ? val : 20;
  };

  // ── Pin click handler ─────────────────────────────────────────────────────
  const handlePinClick = (compassKey, rank) => {
    setSelectedPin({ key: compassKey, rank });

    if (compassKey === 'center') {
      setSelectedPinEntries(centerCellTop);
    } else {
      const entries = [...centerCellTop].filter(e => e.id !== placeId);
      const brandEntry = centerCellTop.find(e => e.id === placeId) || {
        id: placeId,
        name: brandName,
        rank,
      };
      const updatedBrand = { ...brandEntry, rank };
      entries.push(updatedBrand);
      entries.sort((a, b) => (a.rank || 99) - (b.rank || 99));

      const reranked = entries.map((e, idx) => ({
        ...e,
        rank: e.id === placeId ? rank : (idx + 1 <= rank ? idx + 1 : idx + 2),
      }));
      reranked.sort((a, b) => a.rank - b.rank);
      setSelectedPinEntries(reranked);
    }
  };

  // ── Stats ─────────────────────────────────────────────────────────────────
  const statsData = rankingData ? (() => {
    const all  = rankingData.map(v => Math.min(v ?? 20, 20));
    const top3 = all.filter(r => r <= 3).length;
    const avg  = (all.reduce((a, b) => a + b, 0) / all.length).toFixed(1);
    const notR = all.filter(r => r >= 20).length;
    const best = Math.min(...all);
    return { top3, avg, notR, best };
  })() : null;

  const selRank = selectedPin?.rank;
  const selKey  = selectedPin?.key;
  const isSelCenter = selKey === 'center';

  const panelEntries = selectedPin
    ? (selectedPin.key === 'center' ? centerCellTop : selectedPinEntries)
    : centerCellTop;
  const panelTitle = selectedPin ? (DIR_LABELS[selKey] || selKey) : 'Center location';

  const printStyle = `@media print { .map-kw-print-label { display: block !important; } } .map-kw-print-label { display: none; }`;

  // All 13 compass keys rendered on the simulated map, center first
  const ALL_KEYS = ['center', ...Object.keys(GRID_MAP).filter(k => k !== 'center')];

  const radiusCircleSize = Math.round(120 + (gridRadius - 1) * 45); // purely decorative scaling

  return (
    <div className="card" id="card-8">
      <style>{printStyle}</style>

      <div className="eyebrow">GMB Map Ranking</div>
      <h2 className="ctitle">Local Search Ranking</h2>
      <p className="cdesc">
        Where your brand ranks on Google Maps for each keyword — across a local grid around your business location.
      </p>

      {loading && (
        <div className="gmb-rank-fetch show">
          <div className="spinner" />
          <span>Checking local map rankings for your keywords…</span>
        </div>
      )}

      <div className={`gmb-rank-wrap${!loading ? ' show' : ''}`}>

        {/* PDF print label */}
        <div className="map-kw-print-label" style={{
          fontSize: 13, fontWeight: 600, color: '#6B4FA0',
          marginBottom: 12, padding: '6px 12px',
          background: 'rgba(107,79,160,0.07)', borderRadius: 8, display: 'none',
        }}>
          Keyword: <strong>{selectedKeyword}</strong>
        </div>

        {/* Controls */}
        <div className="map-controls">
          <select
            className="kw-select"
            value={selectedKeyword}
            onChange={(e) => setSelectedKeyword(e.target.value)}
          >
            {pillarKeywords.length
              ? pillarKeywords.map(kw => <option key={kw} value={kw}>{kw}</option>)
              : <option>No keywords</option>}
          </select>

          <div className="radius-wrap">
            Grid radius
            <input
              type="range"
              min="1" max="5" step="0.5"
              value={gridRadius}
              onChange={(e) => setGridRadius(parseFloat(e.target.value))}
            />
            <span className="radius-val">{gridRadius} km</span>
          </div>

          <button
            type="button"
            onClick={() => fetchRankingData(true)}
            style={{
              background: 'none', border: 'none', cursor: 'pointer',
              fontSize: 12, fontWeight: 600, color: 'var(--thistle)',
            }}
            title="Refresh ranking data"
          >
            ↻ Refresh
          </button>
        </div>

        {/* Legend */}
        <div className="map-legend">
          <div className="mleg"><div className="mleg-dot mleg-pack" /> #1–3 Local Pack</div>
          <div className="mleg"><div className="mleg-dot mleg-near" /> #4–6 Near Pack</div>
          <div className="mleg"><div className="mleg-dot mleg-weak" /> #7–9 Weak</div>
          <div className="mleg"><div className="mleg-dot mleg-no" /> Not Ranked</div>
          <div className="mleg"><div className="mleg-dot mleg-center" /> Your Location</div>
        </div>

        {/* Simulated Map */}
        <div className="map-outer">
          <div className="map-bg">
            <div className="map-road-h" style={{ top: '33%' }} />
            <div className="map-road-h" style={{ top: '66%' }} />
            <div className="map-road-v" style={{ left: '33%' }} />
            <div className="map-road-v" style={{ left: '66%' }} />
            <div className="map-road-h" style={{ top: '50%', height: 4, opacity: 0.5 }} />
            <div className="map-road-v" style={{ left: '50%', width: 4, opacity: 0.5 }} />

            <div
              className="radius-circle"
              style={{ width: radiusCircleSize, height: radiusCircleSize }}
            />

            <div className="grid-pins">
              {ALL_KEYS.map((key) => {
                const rank = getRank(key);
                const pos = pinPosition(key);
                const isCenter = key === 'center';
                const isSelected = selectedPin?.key === key;
                return (
                  <div
                    key={key}
                    className={`grid-pin ${isCenter ? 'pin-center' : rankPinClass(rank)}`}
                    style={{
                      top: `${pos.top}%`,
                      left: `${pos.left}%`,
                      outline: isSelected ? '2px solid #1C1626' : 'none',
                      outlineOffset: isSelected ? 2 : 0,
                    }}
                    onClick={() => handlePinClick(key, rank)}
                  >
                    {isCenter ? 'you' : rankLabel(rank)}
                    <span className="pin-tooltip">
                      {DIR_LABELS[key] || key} — {rankLabel(rank)}
                    </span>
                    {isCenter && <span className="center-label">Your Location</span>}
                  </div>
                );
              })}
            </div>

            <div className="map-credit">Simulated · Google Maps API on live version</div>
          </div>
        </div>

        {/* Selected point info box */}
        <div
          style={{
            display: 'flex', alignItems: 'flex-start', gap: 12,
            background: selectedPin ? rankBg(selRank) : 'rgba(255,255,255,.65)',
            border: `1px solid ${selectedPin ? rankBorder(selRank) : 'rgba(107,79,160,.1)'}`,
            borderRadius: 12, padding: '14px 16px', marginBottom: 16, minHeight: 52,
            transition: 'border-color .2s, background .2s',
          }}
        >
          <span style={{ fontSize: 18, flexShrink: 0 }}>
            {!selectedPin ? '◎' : selRank <= 3 ? '✦' : selRank <= 6 ? '◈' : selRank <= 9 ? '◇' : '✕'}
          </span>
          <div>
            {!selectedPin ? (
              <>
                <div style={{ fontSize: 14, fontWeight: 500, color: 'var(--ink2)' }}>
                  Click any point on the map to see your ranking and nearby competitors
                </div>
                <div style={{ fontSize: 12, color: 'var(--muted)' }}>13 points — center + N / E / W / S rings</div>
              </>
            ) : (
              <>
                <div style={{ fontSize: 14, fontWeight: 500, color: isSelCenter ? '#6B4FA0' : rankColor(selRank) }}>
                  {brandName} is {selRank >= 20 ? 'not in top 20' : <><strong>ranked #{selRank}</strong></>} — {DIR_LABELS[selKey] || selKey}
                </div>
                <div style={{ fontSize: 12, color: 'var(--muted)' }}>
                  {isSelCenter ? 'Center of audit area' : rankMsg(selRank)}
                </div>
              </>
            )}
          </div>
        </div>

        {/* Stats row */}
        {statsData && (
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: 8, marginBottom: 16 }}>
            {[
              { label: 'Best rank',   val: `#${statsData.best}`,  color: '#16a34a' },
              { label: 'Avg rank',    val: `#${statsData.avg}`,   color: '' },
              { label: 'Top 3 spots', val: `${statsData.top3}/9`, color: '#16a34a' },
              { label: 'Not ranked',  val: `${statsData.notR}`,   color: '#dc2626' },
            ].map(s => (
              <div key={s.label} style={{
                background: 'rgba(107,79,160,.05)', border: '1px solid rgba(107,79,160,.1)',
                borderRadius: 10, padding: 12, textAlign: 'center',
              }}>
                <div style={{ fontSize: 11, color: 'var(--muted)', marginBottom: 4 }}>{s.label}</div>
                <div style={{ fontFamily: 'monospace', fontSize: 20, fontWeight: 600, color: s.color || 'var(--ink)' }}>{s.val}</div>
              </div>
            ))}
          </div>
        )}

        {/* Ranking list — reflects whichever point is selected, defaults to center */}
        <div className="rank-legend">
          <div className="rank-legend-title">Rankings for {panelTitle}</div>
          <div className="rank-items">
            {!loading && panelEntries.length ? [...panelEntries]
              .sort((a, b) => (a.rank || 99) - (b.rank || 99))
              .map((entry, idx) => {
                const rank    = entry.rank || (idx + 1);
                const isBrand = entry.id === resolvedPlaceId || entry.id === placeId;
                const rankCol = rank > 6 ? '#dc2626' : rank > 3 ? '#d97706' : '#059669';
                return (
                  <div key={idx} className="rank-item">
                    <div className="rank-pos" style={{ background: rankCol }}>{rank}</div>
                    <span className="rank-biz">
                      {entry.name}
                      {isBrand && (
                        <span style={{ fontSize: 10, color: 'var(--thistle)', marginLeft: 6 }}>· Your Brand</span>
                      )}
                    </span>
                  </div>
                );
              }) : !loading && (
                <div style={{ padding: '16px 4px', textAlign: 'center', color: 'var(--muted)', fontSize: 12 }}>
                  No ranking data available for this point.
                </div>
              )}
          </div>
        </div>

        {/* AI Insight */}
        {currentInsightPrompt && currentCacheKey && !loading && (
          <AIInsightBox
            key={currentCacheKey}
            title="Map Ranking Insight"
            cacheKey={currentCacheKey}
            prompt={currentInsightPrompt}
            autoGenerate={!!GEMINI_API_KEY}
          />
        )}
        {!currentInsightPrompt && !loading && (
          <div className="insight-box" id="insight-box-8">
            <div className="insight-header">
              <div className="insight-title">
                <svg viewBox="0 0 24 24" width="20" height="20">
                  <path d="M12 2a7 7 0 00-7 7c0 2.6 1.4 4.9 3.5 6.2V17a1 1 0 001 1h5a1 1 0 001-1v-1.8C17.6 13.9 19 11.6 19 9a7 7 0 00-7-7zm2 17h-4v1a1 1 0 001 1h2a1 1 0 001-1v-1z" />
                </svg>
                Local Ranking Insight
              </div>
            </div>
            <div className="insight-text" id="insight-text-8">
              {centerCellTop.length
                ? `Your brand ${brandName} ${centerCellTop[0]?.rank ? `ranks #${centerCellTop[0].rank}` : 'does not appear'} for "${selectedKeyword}" at the center location. ${
                    centerCellTop[0]?.rank <= 3 ? 'This is in the Local Pack!' :
                    centerCellTop[0]?.rank <= 6 ? 'Close to the Local Pack.' :
                    'Optimise your GMB profile.'
                  }`
                : 'No ranking data available. Try a different keyword or location.'}
            </div>
          </div>
        )}
      </div>

      <button className="btn" onClick={onContinue} style={{ marginTop: 20 }}>
        Continue
        <svg viewBox="0 0 24 24" fill="white">
          <path d="M12 4l-1.4 1.4L16.2 11H4v2h12.2l-5.6 5.6L12 20l8-8z" />
        </svg>
      </button>
    </div>
  );
};

export default GmbAuditPage;